import React from "react";
import get from "lodash/get";
import { useTranslation } from "react-i18next";
import ToolTip from "../tooltip";
import { STRIPE } from "../../constants";
import getCycleCardImagePath from "../../utils/get-cycle-card-image-path";
import { useRillContext } from "../../rill/RillReact/share/base";

const LibraryProgramCard = (props) => {
  const { t } = useTranslation("coaching-portal");
  const { locals } = useRillContext();

  // cycle object is not available
  const { program, cardIndex, referrer } = props;

  const { activeUser, activeUserToRequest } = locals;

  const { cycleId, cycleAuthor, cycleImage, cycleName, cycleProgramTotal } =
    program;

  // Don't allow standard users to schedule premium programs
  const userPlan = get(activeUserToRequest, "stripe.plan", "");
  const isPremium =
    userPlan === STRIPE.PLANS.V2.premiumMonthly ||
    userPlan === STRIPE.PLANS.V2.premiumAnnually;
  const isAdmin = activeUser.permissions?.includes("admin");
  const isAmbassador = activeUser.permissions?.includes("ambassador");

  const suggestUpradePath = "/actions/refresh?modal[type]=suggest-upgrade";
  const addToCalendarPath = `/actions/refresh/?modal[type]=add-to-calendar&cycleId=${cycleId}&wholeCycle=false&program=${program.order}`;

  const style = program.cycleType === "premium" ? "alt-premium" : "alt-mine";

  const image = getCycleCardImagePath({
    image: { file: cycleImage.replace("/api/file/", "") },
  });

  return (
    <div className="column" data-col="1/3">
      <div className={`Program-Preview ${style}`}>
        <div className="image" style={{ backgroundImage: `url(${image})` }}>
          <a
            href={`/dashboard/program-library/program-overview/${cycleId}?program=${program.order}&referrer=${referrer}`}
            className="overview-program"
          >
            {t("libraryProgramCard.overview")}
            <img src="/img/svg/icon_arrow-down.svg" alt="" />
          </a>
          <a
            href={`/dashboard/program-library/program-preview/${cycleId}?program=${program.order}&referrer=${referrer}`}
            className="preview-program"
          >
            {t("libraryProgramCard.preview")}&nbsp;
            <img width="20" height="20" src="/img/eye-white.webp" alt="" />
          </a>
        </div>
        <div className="details">
          <div className="title">{program.name}</div>
          <div className="author">{cycleAuthor}</div>
          <ToolTip id="add-to-calendar" body={t("libraryProgramCard.addToCalendar")}>
            <a
              href={
                program.cycleType === "premium" &&
                !isPremium &&
                !isAmbassador &&
                !isAdmin
                  ? suggestUpradePath
                  : addToCalendarPath
              }
            >
              <div className="add">+</div>
            </a>
          </ToolTip>
        </div>
        <div className="cycle">
          <div className="title">{cycleName}</div>
          <div className="number">
            <b>{program.order}</b>/{cycleProgramTotal}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LibraryProgramCard;
